import { Route } from 'vue-router';

// depannage.homeserve.fr is decommissioned except the order-tracking flow.
// Every other path is a server-side 301 redirect declared in deployer.yml.
export const followOrderRouteNames = ['followOrder', 'followOrderTrackingUUID'];

// New site visitors are sent to when /suivi is opened without a tracked order.
// Mirrors the server-side 301 target of /suivre-votre-commande in deployer.yml.
export const NEW_SITE_URL = 'https://www.homeserve.fr/depannage';

// Reaching /suivi without a valid tracked order (no UUID flow) used to fall back
// to the SPA login page (/suivre-votre-commande), which re-exposed the whole
// decommissioned site through client-side navigation. Send such visitors to the
// new site instead, via a real navigation so they leave the SPA entirely.
export function redirectToNewSite() {
  window.location.assign(NEW_SITE_URL);
}

// Server-side 301 redirects only fire on a full HTTP request. Once the SPA is
// loaded on /suivi, client-side navigation never reaches the server, so we must
// detect when a navigation leaves the tracking flow and turn it into a real
// navigation (see router.beforeEach).
export function isLeavingFollowOrder(to: Pick<Route, 'name'>, from: Pick<Route, 'name'>) {
  return (
    !!from.name && followOrderRouteNames.includes(from.name) && (!to.name || !followOrderRouteNames.includes(to.name))
  );
}
